import React from 'react';

export const Internet = ({ height="63px", width="123px",padding="12px", style=''})=> (
    <svg  role='presentation' aria-label='' width={width} height={height} padding={padding} viewBox="0 0 123 63" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <path fill="#9FB7C1" d="M22.461.648c-3.085 0-5.586 2.518-5.586 5.624v55.775h90V6.272c0-3.106-2.502-5.624-5.588-5.624H22.461z"/>
            <path fill="#96A7AF" d="M22.453.648c-3.08 0-5.579 2.518-5.579 5.624v55.775H93.22L32.309.647h-9.856z"/>
            <path fill="#32A0DA" d="M21.975 51.64h80.323V5.575H21.975z"/>
            <path fill="#2990C7" d="M37.713 6H22v45.435h61.148z"/>
            <path fill="#85949B" d="M11.381 57.396c-2.834 0-5.131 2.174-5.131 4.854h110.81c0-2.68-2.297-4.854-5.132-4.854H11.381z"/>
            <path stroke="#CAD9E0" stroke-linecap="round" stroke-width=".75" d="M1 62.25h121.031"/>
            <g stroke="#D4E4EB" stroke-linecap="round" stroke-width="1.5">
                <path d="M66.03 39.997a5.81 5.81 0 0 0-8.222 0M71.858 34.737c-5.494-5.494-14.384-5.494-19.878 0M77.686 29.477c-8.715-8.716-22.818-8.716-31.534 0M83.514 24.216c-11.936-11.935-31.253-11.935-43.19 0"/>
            </g>
        </g>
    </svg>

);
